export default {
  home: {
    metaTitle: "USFans Spreadsheet – Przewodnik, recenzje i zasoby",
    metaDescription: "Poznaj arkusz USFans: zasoby twórców, recenzje, informacje o wysyłce, kupony, poradniki bezpieczeństwa, porównania i praktyczne wskazówki.",
    hero: {
      badge: "Niezależne źródło · Regularnie aktualizowane",
      title: "USFans Spreadsheet — Twoje kompletne centrum zasobów USFans",
      subtitle: "Znajdź lepsze informacje dzięki arkuszowi USFans. Poznaj zasoby, informacje o twórcach, recenzje, przewodniki wysyłkowe, kupony, dane magazynowe, wskazówki bezpieczeństwa i praktyczne poradniki — wszystko w jednym, łatwym w obsłudze miejscu.",
      primaryCta: "Poznaj arkusz USFans",
      secondaryCta: "Kup teraz",
      trust: "Niezależne źródło · Przejrzyste przewodniki · Regularnie aktualizowane",
    },
    what: {
      title: "Czym jest arkusz USFans?",
      p1: "Arkusz USFans to uporządkowane źródło, które ułatwia wyszukiwanie, porównywanie i rozumienie informacji związanych z USFans. Zamiast przeszukiwać rozproszone strony, możesz w jednym miejscu przeglądać przewodniki, zasoby twórców, szczegóły wysyłki, recenzje i zalecenia dotyczące bezpieczeństwa.",
      p2: "Ponieważ arkusz grupuje informacje według kategorii, pomaga szybko przejść od ogólnego wyszukiwania do konkretnego produktu lub twórcy — bez skakania między dziesiątkami niepowiązanych stron.",
      cta: "Przeglądaj centrum arkusza",
    },
    features: {
      title: "Wszystko, co musisz wiedzieć o USFans",
      subtitle: "Szybki przegląd najbardziej przydatnych tematów wokół arkusza USFans.",
      spreadsheet: { title: "Arkusz USFans", desc: "Poznaj centralne źródło arkusza i powiązane informacje." },
      review: { title: "Recenzja USFans", desc: "Zrozum kluczowe funkcje, zalety, ograniczenia i uwagi użytkowników." },
      shipping: { title: "Koszt wysyłki USFans", desc: "Dowiedz się, co wpływa na ceny wysyłki i jak porównywać opcje." },
      coupon: { title: "Kupon USFans", desc: "Znajdź informacje o promocjach i o tym, jak działają kupony." },
      discount: { title: "Kod rabatowy USFans", desc: "Dowiedz się, jak zweryfikować informacje o rabatach przed użyciem kodu." },
      warehouse: { title: "Magazyn USFans", desc: "Zrozum kwestie magazynu, przechowywania i realizacji zamówień." },
      legit: { title: "Czy USFans jest legalny?", desc: "Dowiedz się, jak ocenić wiarygodność, zaufanie i bezpieczeństwo." },
      safety: { title: "Bezpieczeństwo USFans", desc: "Postępuj zgodnie z praktycznymi zaleceniami dotyczącymi prywatności i konta." },
    },
    popular: {
      title: "Zacznij od pełnego przewodnika",
      subtitle: "Nasz szczegółowy przewodnik wyjaśnia, czym jest arkusz USFans, dlaczego ma znaczenie i jak z niego korzystać.",
      cta: "Przeczytaj pełny przewodnik",
    },
    faqSection: {
      title: "Często zadawane pytania",
      items: [
        { q: "Czym jest arkusz USFans?", a: "To uporządkowane źródło, które porządkuje informacje o USFans — twórców, kategorie, wysyłkę i więcej — w jednym łatwym do przeglądania centrum." },
        { q: "Czy przeglądanie arkusza USFans jest darmowe?", a: "Przeglądanie przewodników i kategorii jest darmowe. Zakupy odbywają się w głównym sklepie." },
        { q: "Jak znaleźć konkretny produkt?", a: "Skorzystaj z listy kategorii na tej stronie, aby przejść bezpośrednio do odpowiedniej sekcji głównego sklepu." },
        { q: "Czy USFans jest legalny?", a: "Zawsze weryfikuj informacje w oficjalnych źródłach i sprawdzaj politykę sklepu przed zakupem." },
      ],
    },
    finalCta: {
      title: "Gotowy, aby przejrzeć cały sklep?",
      subtitle: "Przejdź bezpośrednio na główną stronę, aby przeglądać wszystkie kategorie i produkty.",
      primary: "Odwiedź główną stronę",
      secondary: "Kup teraz",
    },
  },
};